import React from 'react';
import { motion } from 'framer-motion';

export default function HeroSubheadline() {
  return (
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="text-lg sm:text-xl text-gray-300 lg:text-left max-w-xl mx-auto lg:mx-0"
    >
      Gain 360° insights from peers, managers, and stakeholders. Identify strengths, close gaps, and advance confidently into your next role
    </motion.p>
  );
}